import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { CreditCardClearanceReportEntity } from '../../../../../api/types/payment-gateway/credit-card-clearance-entity';
import { CreditCardClarenceFilterType } from '../credit-card-clarence-filter.type';

// Backend expects DD/MM/YYYY (4-digit year) strings for the date filters.
const toDdMmYyyy = (date: Date | null): string | null => {
  if (!date) return null;
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  return `${day}/${month}/${year}`;
};

export const getCreditCardClarenceListOperation = async (
  filters: CreditCardClarenceFilterType,
  offset: number,
  limit: number,
  setData: (data: CreditCardClearanceReportEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const trimmedStatusCode = filters.statusCode?.trim() ?? '';

    const res = await appApi.getCreditCardClearanceList({
      offset,
      limit,
      startDate: toDdMmYyyy(filters.startDate),
      endDate: toDdMmYyyy(filters.endDate),
      cardBrand: filters.cardBrand ?? [],
      creditCardClearanceStatuses: filters.creditCardClearanceStatuses ?? [],
      creditCardClearanceType: filters.creditCardClearanceType ?? [],
      statusCode: trimmedStatusCode === '' ? null : trimmedStatusCode,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body.data ?? []);
    setTotal(res.data.body.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
